module.exports = __webpack_public_path__ + "img/administration.5cea383b.svg";